import React, {useState} from 'react';
import logoPositiveSmall from '../assets/img/logo_positivo_small.png';
import {Container} from 'reactstrap';
import {Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem} from 'reactstrap';
import {Link} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


const NavigationBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);
    const onClickNavBrand = () => setIsOpen(false);

    return (
        <Navbar expand="lg" id='mainNav' className='fixed-top' light style={{backgroundColor: '#fff', borderBottom: "1px solid rgba(33, 37, 41, 0.1)"}} >
            <Container>
                <NavbarBrand tag={Link} exact='true' to='/' onClick={onClickNavBrand}>
                    <img src={logoPositiveSmall} width="160px" alt='logo small' />
                </NavbarBrand>
                <NavbarToggler onClick={toggle} style={{outlineColor: "var(--logo_1)"}}/>
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="ml-auto" navbar>
                        <NavItem style={{lineHeight: '40px'}}>
                            <Link className='navbar-link' to='/specialization' onClick={toggle}>Servizi</Link>
                        </NavItem>
                        <NavItem style={{lineHeight: '40px'}}>
                            <Link className='navbar-link' to='/about' onClick={toggle}>Chi sono</Link>
                        </NavItem>
                        <NavItem style={{lineHeight: '40px'}}>
                            <Link className='navbar-link' to='/contacts' onClick={toggle}>Contatti</Link>
                        </NavItem>
                        <NavItem style={{lineHeight: '40px'}}>
                            <Link className='navbar-link' to='/articles' onClick={toggle}>Approfondimenti</Link>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Container>
        </Navbar>
    );
};

export default NavigationBar;
